import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import { useAuthStore } from '../stores/auth-store'

import AuthLayout from '../layouts/AuthLayout.vue'
import AppLayout from '../layouts/AppLayout.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'dashboard' },
  },
  {
    name: 'admin',
    path: '/',
    component: AppLayout,
    redirect: { name: 'dashboard' },
    meta: { requiresAuth: true },
    children: [
      {
        name: 'dashboard',
        path: 'dashboard',
        component: () => import('../pages/admin/dashboard/Dashboard.vue'),
      },
      {
        name: 'settings',
        path: 'settings',
        component: () => import('../pages/settings/Settings.vue'),
      },
      {
        name: 'preferences',
        path: 'preferences',
        component: () => import('../pages/preferences/Preferences.vue'),
      },
      {
        name: 'users',
        path: 'users',
        component: () => import('../pages/users/UsersPage.vue'),
      },
      {
        name: 'providers',
        path: 'providers',
        component: () => import('../pages/providers/ProvidersPage.vue'),
      },
      {
        name: 'invoices',
        path: 'invoices',
        component: () => import('../pages/invoices/InvoicesPage.vue'),
      },
      {
        name: 'payment-schedules',
        path: 'payment-schedules',
        component: () => import('../pages/payment-schedules/PaymentSchedulesPage.vue'),
      },
      {
        name: 'cartera',
        path: 'cartera',
        component: () => import('../pages/cartera/CarteraPage.vue'),
      },
      {
        name: 'cartera-provider',
        path: 'cartera/:providerId',
        component: () => import('../pages/cartera/ProviderLedgerPage.vue'),
        props: true,
      },
      {
        name: 'planilla',
        path: 'planilla',
        component: () => import('../pages/planilla/PlanillaPage.vue'),
      },
      {
        name: 'inventario',
        path: 'inventario',
        component: () => import('../pages/inventario/InventarioPage.vue'),
      },
      {
        name: 'tarjetas-regalo',
        path: 'tarjetas-regalo',
        component: () => import('../pages/tarjetas-regalo/TarjetasRegaloPage.vue'),
      },
      {
        name: 'precios',
        path: 'pos/precios',
        component: () => import('../pages/pos/precios/PreciosPage.vue'),
      },
      {
        name: 'categorias',
        path: 'pos/categorias',
        component: () => import('../pages/pos/categorias/CategoriasPage.vue'),
      },
      {
        name: 'codigos-barra',
        path: 'pos/codigos-barra',
        component: () => import('../pages/pos/codigos-barra/CodigosBarraPage.vue'),
      },
      {
        name: 'clientes-puntos',
        path: 'programa-puntos/clientes',
        component: () => import('../pages/programa-puntos/ClientesPuntosPage.vue'),
      },
      {
        name: 'premios',
        path: 'programa-puntos/premios',
        component: () => import('../pages/programa-puntos/PremiosPage.vue'),
      },
      {
        name: 'configuracion-puntos',
        path: 'programa-puntos/configuracion',
        component: () => import('../pages/programa-puntos/ConfiguracionPuntosPage.vue'),
      },
      {
        name: 'pos-sync-status',
        path: 'configuracion/pos-sync-status',
        component: () => import('../pages/configuracion/EstadoSincronizacionPage.vue'),
      },
    ],
  },
  {
    path: '/auth',
    component: AuthLayout,
    children: [
      {
        name: 'login',
        path: 'login',
        component: () => import('../pages/auth/Login.vue'),
      },
      {
        name: 'recover-password',
        path: 'recover-password',
        component: () => import('../pages/auth/RecoverPassword.vue'),
      },
      {
        name: 'recover-password-email',
        path: 'recover-password-email',
        component: () => import('../pages/auth/CheckTheEmail.vue'),
      },
      {
        path: '',
        redirect: { name: 'login' },
      },
    ],
  },
  {
    name: '404',
    path: '/404',
    component: () => import('../pages/404.vue'),
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    }
    // For some reason using documentation example doesn't scroll on page navigation.
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' }
    } else {
      window.scrollTo(0, 0)
    }
  },
  routes,
})

router.beforeEach((to) => {
  const authStore = useAuthStore()
  const requiresAuth = to.matched.some((record) => record.meta.requiresAuth)

  if (requiresAuth && !authStore.isAuthenticated) {
    return { name: 'login', query: { redirect: to.fullPath } }
  }

  if (to.name === 'login' && authStore.isAuthenticated) {
    return { name: 'dashboard' }
  }
})

export default router
